import React, { useState } from "react";
import SignUpInfo from "./SignUpInfo";
import PersonalInfo from "./PersonalInfo";
import OtherInfo from "./OtherInfo";
import MoreInfo from "./MoreInfo";
import MiRut from "./Rut";
import { useAuth } from "../../context/authContext";
import { useNavigate } from "react-router-dom";
import Cierre from "../../Cierre";

//import axios from 'axios';
//import { google } from "googleapis";

import { collection, addDoc, doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";

export default function Form() {
  const cierre = Cierre();
  const navigate = useNavigate();
  const timestamp = new Date();
  const formattedDat = timestamp.toISOString();
  const formattedDate = timestamp.toISOString().split("T")[0];
  const { user } = useAuth();
  /*const [croquis, setCroquis] = useState({ 
    imgRef: "", });*/
  const [croquis, setCroquis] = useState([]);

  const [page, setPage] = useState(0);
  const [formData, setFormData] = useState({
    interruptorGeneral: "",
    nombreInstalador: "",
    apellidoInstalador: "",
    folio: "",
    email: "",
    nombrePropietario: "",
    apellidoPropietario: "",
    rut: "",
    direccionPropietario: "",
    comunaPropietario: "",
    regionInstalacion: "",
    coordenadas: "",
    destinoPropiedad: "",
    largoAlimentador: "",
    tipoCable: "",
    aislacionCable: "",
    calibreAlimentador: "",
    um: "",
    canalizacion: "",
    spt: "",
    enlaceUrl: "",
    ohmnimetro: "",
  });

  const FormTitles = [
    "Información instalador ",
    "Información propietario",
    "Información instalación",
    "Información técnica",
  ];

  const PageDisplay = () => {
    if (page === 0) {
      return <SignUpInfo formData={formData} setFormData={setFormData} />;
    } else if (page === 1) {
      return <PersonalInfo formData={formData} setFormData={setFormData} />;
    } else if (page === 2) {
      if (
        formData.nombrePropietario.trim() === "" ||
        formData.apellidoPropietario.trim() === "" ||
        formData.rut.trim() === "" ||
        formData.direccionPropietario.trim() === "" ||
        formData.comunaPropietario.trim() === "" ||
        formData.regionInstalacion.trim() === "" ||
        formData.coordenadas.trim() === ""
      ) {
        alert("Por favor, completa todos los campos antes de continuar.");
      } else {
        return <OtherInfo formData={formData} setFormData={setFormData} />;
      }
    } else if (page === 3) {
      if (
        formData.destinoPropiedad.trim() === "" ||
        formData.largoAlimentador.trim() === "" ||
        formData.tipoCable.trim() === "" ||
        //formData.aislacionCable.trim() === '' ||
        formData.calibreAlimentador.trim() === "" ||
        formData.um.trim() === "" ||
        formData.canalizacion.trim() === ""
      ) {
        alert("Por favor, completa todos los campos antes de continuar.");
      } else {
        return (
          <MoreInfo
            formData={formData}
            setFormData={setFormData}
            croquis={croquis}
            setCroquis={setCroquis}
          />
        );
      }
    } else if (page === 99) {
      return <MiRut formData={formData} setFormData={setFormData} />;
    }
  };
  return (
    <div className="form">
      <div className="progressbar">
        <div
          style={{
            width:
              page === 0
                ? "25%"
                : page === 1
                ? "50%"
                : page === 2
                ? "75%"
                : "100%",
          }}
        ></div>
      </div>
      <div className="form-container">
        <div className="header">
          <h1>{FormTitles[page]} </h1>
        </div>
        <div className="body">{PageDisplay()} </div>
        <div className="footer">
          <button
            hidden={page === 0}
            onClick={() => {
              setPage((currPage) => currPage - 1);
            }}
          >
            Atrás
          </button>
          <button
            onClick={async (data) => {
              // Validar campos
              if (
                formData.interruptorGeneral.trim() === "" ||
                formData.nombreInstalador.trim() === "" ||
                formData.apellidoInstalador.trim() === "" ||
                formData.folio.trim() === "" ||
                formData.email.trim() === ""
              ) {
                alert(
                  "Por favor, completa todos los campos antes de continuar."
                );
                return;
              }

              if (page === FormTitles.length - 1) {
                if (
                  formData.spt.trim() === "" ||
                  formData.enlaceUrl.trim() === "" ||
                  formData.ohmnimetro.trim() === ""
                ) {
                  alert(
                    "Por favor, completa todos los campos antes de continuar."
                  );
                } else {
                  alert("Ahora serás redirigido al portal de pago");
                  //navigate("cierre");
                 

                  //console.log(formData)
                  await setDoc(
                    doc(db, formattedDate, user.displayName + formattedDat),
                    {
                      formData,
                    }
                  );

                  //--------------------------------------------------------

                  /*
               
                  // Configuración de autenticación
                  const auth = new google.auth.GoogleAuth({
                    keyFile: 'src/key.json',
                    scopes: ['https://www.googleapis.com/auth/spreadsheets'],
                  });
                  const sheets = google.sheets({ version: 'v4', auth });
              
                  // ID de tu hoja de cálculo de Google Sheets
                  const spreadsheetId = '1DM43JEKj66FkD438dJM0RQZpyW2RHxNiYtz7skISmU8';
              
                  // Nombre de la hoja en la que deseas escribir los datos
                  const sheetName = 'Hoja1';
              
                  // Crear el cuerpo de la solicitud
                   const valueInputOption = 'RAW';
                  const resource = {
                    values: [
                      [data.rut, data.nombreInstalador, data.apellidoInstalador], // Ajusta según tus campos
                    ],
                  };
              
                  // Realizar la solicitud de escritura en Sheets
                  await sheets.spreadsheets.values.append({
                    spreadsheetId,
                    range: sheetName,
                    valueInputOption,
                    resource,
                  });
              
                  console.log('Datos exportados a Sheets correctamente.');

//--------------------------------------------------------
*/
                  //https://script.google.com/macros/s/AKfycbwyjzUBrpb1Fi5LIfWkIORHOabsfw-g1CEv4evD5Lc9lXms6PxfPX0GPC0MF59ad81V4A/exec
                  try {
                    const res = await fetch(
                      "https://script.google.com/macros/s/AKfycbw2QOUQwcQ6y47fQ9NrVu9bfofRIEC8hf6-U0s7xKzsdCuo5qcyMJzDGm4Pj4YGNgUgbw/exec",
                      {
                        mode: "no-cors",
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify(formData),
                      }
                    );

                    window.location.assign(
                      "https://drawingsmachines.com/pasarela2.html"
                    );

                    if (res.ok) {
                      console.log("datos enviados con  exito");
                     
                    }
                  } catch (error) {
                    console.log(error);
                    
                  }
                }
              } else {
                setPage((currPage) => currPage + 1);
              }
            }}
          >
            {page === FormTitles.length - 1 ? "Enviar" : "Siguiente"}
          </button>
        </div>
      </div>
    </div>
  );
}
